import { reactive } from 'vue';

/**
 * Mapa compartido de fotos de perfil de la intranet (red.jurisleg.com),
 * donde se hace el login cruzado. Se cachea una sola vez por sesión y se
 * consulta por email (clave universal, no solo para quien ha hecho SSO).
 */
const state = reactive({ map: {}, loaded: false, loading: false });

function intranetToken() {
  try {
    return (JSON.parse(localStorage.getItem('user') || '{}')).intranet_token || null;
  } catch (e) {
    return null;
  }
}

export function loadIntranetPhotos() {
  if (state.loaded || state.loading) return Promise.resolve(state.map);
  const tok = intranetToken();
  if (!tok) return Promise.resolve(state.map);

  state.loading = true;
  return fetch('https://red.jurisleg.com/api/users', {
    headers: { Authorization: 'Bearer ' + tok, Accept: 'application/json' }
  })
    .then(r => (r.ok ? r.json() : {}))
    .then(list => {
      const arr = Array.isArray(list) ? list : (list.users || list.data || []);
      const map = {};
      arr.forEach(u => {
        if (u.email && u.photo && !/default\.png$/i.test(u.photo)) {
          map[u.email.toLowerCase().trim()] = u.photo;
        }
      });
      state.map = map;
      state.loaded = true;
      state.loading = false;
      return map;
    })
    .catch(() => {
      state.loading = false;
      return state.map;
    });
}

/** Devuelve la URL de foto del intranet para un email, o null. */
export function intranetPhoto(email) {
  if (!email) return null;
  return state.map[email.toLowerCase().trim()] || null;
}

/**
 * Resuelve la foto de un usuario/miembro del staff: la de la intranet
 * (fuente de verdad) y, si no hay, la propia del CRM como respaldo.
 * Solo tiene sentido para usuarios internos (tienen cuenta en la intranet),
 * no para clientes/colaboradores externos.
 */
export function resolveUserPhoto(user, baseURL) {
  if (!user) return null;
  const ip = intranetPhoto(user.email);
  if (ip) return ip;
  if (user.image && user.image !== 'default.png') return baseURL + 'img/profiles/' + user.image;
  return null;
}

export const intranetPhotosState = state;
